import { IconFont } from '@/components/IconFont'
import OrbitAvatar from '@/components/OrbitAvatar'
import usePageSizeByRef from '@/hooks/usePageSizeByRef'
import useRepositoriesFilter from '@/hooks/useRepositoriesFilter'
import {
  deleteProject,
  getOrganizationProjects,
  updateOrganizationProject
} from '@/services/project/project'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Button, Col, Dropdown, List, Menu, Modal, Result, Row, Space, Typography } from 'antd'
import dayjs from 'dayjs'
import React, { memo, useContext } from 'react'
import { Link } from 'react-router-dom'
import { OrganizationContext } from '..'
import LinkData from '../Common/LinkData'
import AddEditProject from './AddEditProject'
import styles from './index.module.less'

export default memo(function OrganizationProjects() {
  const orgData = useContext(OrganizationContext).orgData!
  const { data: projects = [], run: getProjects, loading } = useRequest(() => getOrganizationProjects(orgData?.id!))

  const { data: filterProjects, filterProps } = useRepositoriesFilter(projects)

  const { ref, pageSize } = usePageSizeByRef(126)

  return (
    <div className={styles.container}>
      <Row justify={'space-between'}>
        <Col>
        </Col>
        <Col>
          <Button
            type={'primary'}
            icon={<IconFont type='icon-add' />}
            onClick={() => {
              AddEditProject.show({
                orgId: orgData.id,
                onSuccess: () => {
                  getProjects()
                }
              })
            }}
          >
            New Project
          </Button>
        </Col>
      </Row>

      <div className={styles.list} ref={ref}>
        {(projects.length > 0) && (
          <List
            loading={loading}
            key={filterProjects.length}
            itemLayout='vertical'
            pagination={{
              pageSize: pageSize,
              hideOnSinglePage: true
            }}
            split={false}
            dataSource={filterProjects}
            renderItem={(project) => (
              <List.Item key={project.id}>
                <div className={'border p-2'} key={project.id}>
                  <Row justify={'space-between'} align={'middle'}>
                    <Space size={'middle'}>
                      <OrbitAvatar size={40} avatar={project.avatar} name={project.name} />
                      <div>
                        <Row align={'middle'}>
                          <Typography.Title level={5} className={'mb-0'}>
                            <Link to={`/main/projects/${project.id}`} target='_blank'>
                              {project.name}
                            </Link>
                            <Typography.Text type='secondary'> ({project.code}) </Typography.Text>
                          </Typography.Title>
                          <Space className={'ml-2'}>
                            <Button size={'small'} className={styles.personal}>
                              {project.personal ? 'Public' : 'Private'}
                            </Button>
                          </Space>
                        </Row>
                        <Typography.Text type='secondary'>{project.description}</Typography.Text>
                        <div>
                          <Space direction={'horizontal'} size={'large'}>
                            <Typography.Text type='secondary'>
                              <IconFont type={'icon-xingxing'} />
                              <span className={'ml-1'}>215</span>
                            </Typography.Text>

                            <Typography.Text type='secondary'>
                              <IconFont type={'icon-circular'} />
                              <span className={'ml-1'}>15</span>
                            </Typography.Text>

                            <Typography.Text type='secondary'>{dayjs(project.updateTime).fromNow()}</Typography.Text>
                          </Space>
                        </div>
                      </div>
                    </Space>
                    <div>
                      <Dropdown
                        arrow
                        overlay={
                          <Menu>
                            <Menu.Item
                              key='edit'
                              onClick={() => {
                                AddEditProject.show({
                                  project,
                                  orgId: orgData.id,
                                  onSuccess: () => {
                                    getProjects()
                                  }
                                })
                              }}
                            >
                              Edit
                            </Menu.Item>
                            <Menu.Item
                              key='delete'
                              onClick={() => {
                                Modal.confirm({
                                  icon: <ExclamationCircleOutlined />,
                                  content: 'Are you sure to delete?',
                                  onOk: async () => {
                                    await deleteProject(project.id)
                                    getProjects()
                                  }
                                })
                              }}
                            >
                              Delete
                            </Menu.Item>
                          </Menu>
                        }
                      >
                        <Button size={'small'} className={styles['item-setting']}>
                          <IconFont type='icon-setting' />
                        </Button>
                      </Dropdown>
                    </div>
                  </Row>
                </div>
              </List.Item>
            )}
          />
        )}

      </div>
    </div>
  )
})
